(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[222],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 75795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SectionTitleBackground; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "showTopArrow"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var SectionTitleBackground = function SectionTitleBackground(_ref) {
  var children = _ref.children,
      _ref$showTopArrow = _ref.showTopArrow,
      showTopArrow = _ref$showTopArrow === void 0 ? true : _ref$showTopArrow,
      rest = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, _objectSpread(_objectSpread({
    showTopArrow: showTopArrow
  }, rest), {}, {
    children: children
  }));
};
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:'';position:absolute;left:0;width:0;height:0;border-style:solid;border-width:175px 50vw 0 50vw;@media screen and (max-width:1047px){border-width:40px 50vw 0 50vw;}"]);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitleBackground__Wrapper",
  componentId: "sc-venkor-0"
})(["position:relative;background-color:", ";padding:", ";&::before{", ";}&::after{", ";bottom:0;border-color:", ";}@media screen and (max-width:1047px){padding:", ";}"], function (_ref2) {
  var bgColor = _ref2.bgColor;
  return bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff';
}, function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var _ref4$showTopArrow = _ref4.showTopArrow,
      showTopArrow = _ref4$showTopArrow === void 0 ? true : _ref4$showTopArrow,
      outerBgColor = _ref4.outerBgColor;
  return showTopArrow ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["", ";top:0;border-color:", " transparent transparent transparent;"], Arrow, outerBgColor === 'thin-blue' ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue : '#fff') : (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["content:none;"]);
}, Arrow, function (_ref5) {
  var bgColor = _ref5.bgColor,
      outerBgColor = _ref5.outerBgColor;
  return "".concat(bgColor === 'trial-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : bgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff', " \n      transparent \n      ").concat(outerBgColor === 'thin-blue' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue) : '#fff');
}, function (_ref6) {
  var padding = _ref6.padding;
  return padding.sp;
});

/***/ }),

/***/ 52143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97749);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-106wc0z-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-106wc0z-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 83193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HistoryPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/convertPx.ts
var convertPx = __webpack_require__(98993);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/SectionTitleBackground/index.tsx
var SectionTitleBackground = __webpack_require__(75795);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Company/CompanyLinks/index.tsx
var CompanyLinks = __webpack_require__(52143);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Company/History/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var HistoryPage = function HistoryPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u4F1A\u793E\u6CBF\u9769",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u3053\u308C\u307E\u3067\u306E\u6B69\u307F\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'company/history/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryMainWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 69,
          sp: 40
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryMain, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "History",
          subTitleText: "\u4F1A\u793E\u6CBF\u9769",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NoteDiv, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Note, {
            children: ["IT\u3092\u7956\u696D\u3068\u3057\u306A\u304C\u3089\u3001\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC\u696D\u614B\u306E\u78BA\u7ACB\u3084\u5C45\u629C\u51FA\u5E97\u306B\u3088\u308BGMS\uFF08\u7DCF\u5408\u30B9\u30FC\u30D1\u30FC\uFF09\u518D\u751F\u3001Retail AI\u306B\u3088\u308BSmart Store Technology \xAE\uFE0F \u306E\u958B\u767A\u3084\u4ED6\u4F01\u696D\u3068\u306E\u5171\u5275\u306A\u3069\u3001\u3042\u3089\u3086\u308B\u3053\u3068\u306B\u6311\u6226\u3057\u3066\u304D\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "1999\u5E74\u304B\u308920\u5E74\u4EE5\u4E0A\u3001\u58F2\u4E0A\u9AD8\u306F\u5897\u52A0\u3057\u7D9A\u3051\u3066\u3044\u307E\u3059\u3002 \u6311\u6226\u306E\u6B74\u53F2\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002"]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            pc: 90,
            sp: 0
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitleBackground/* SectionTitleBackground */.T, {
              bgColor: "white",
              outerBgColor: "thin-blue",
              showTopArrow: false,
              padding: {
                pc: "0 0 ".concat((0,convertPx/* PxToVw */.g)(100, 1440)),
                sp: "80px 0 40px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodTitle, {
                id: "1970",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "\u6D41\u901A\u5C0F\u58F2\xD7IT\u306E\u59CB\u307E\u308A"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                  children: ["1970-1980", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "\u5E74"
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  pc: 0,
                  sp: 40
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodListWrapper, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodList, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["1974", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u3042\u3055\u3072\u5C4B \u958B\u696D"
                        }), "\u798F\u5CA1\u5E02\u306B\u53E4\u7269\u5546\u3001\u30EA\u30B5\u30A4\u30AF\u30EB\u30B7\u30E7\u30C3\u30D7\u3068\u3057\u3066\u958B\u696D\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u524D\u8EAB\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/asahiya.webp",
                        alt: "\u682A\u5F0F\u4F1A\u793E\u3042\u3055\u3072\u3084"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: -200,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["1984", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u3231\u30C8\u30E9\u30A4\u30A2\u30EB\u30AB\u30F3\u30D1\u30CB\u30FC\u8A95\u751F"
                        }), "\u3042\u3055\u3072\u5C4B\u3092\u3231\u30C8\u30E9\u30A4\u30A2\u30EB\u30AB\u30F3\u30D1\u30CB\u30FC\u306B\u5546\u53F7\u5909\u66F4\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u5C0F\u58F2\u5E97\u5411\u3051\u306EPOS\uFF08\u8CA9\u58F2\u6642\u70B9\u60C5\u5831\u7BA1\u7406\uFF09\u30B7\u30B9\u30C6\u30E0\u958B\u767A\u3084\u3001\u5927\u624B\u30B3\u30F3\u30D4\u30E5\u30FC\u30BF\u30FC\u30E1\u30FC\u30AB\u30FC\u306E\u53D7\u8A17\u3092\u884C\u3044\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u300C\u81EA\u5206\u305F\u3061\u3067\u3084\u308B\u300D\u3068\u3044\u3046\u30B9\u30D4\u30EA\u30C3\u30C8\u3067\u3001\u958B\u767A\u3092\u5185\u88FD\u3057\u307E\u3057\u305F\u3002"]
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u30A8\u30EC\u30D3\u30C3\u30C8\u958B\u5E97"
                        }), "AV\u6A5F\u5668\u306A\u3069\u3092\u8CA9\u58F2\u3059\u308B\u5BB6\u96FB\u91CF\u8CA9\u5E97\u3092\u30B9\u30BF\u30FC\u30C8\u3002\uFF08\u73FE\u5728\u306F\u9589\u5E97\uFF09"]
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/elebit.webp",
                        alt: "\u30A8\u30EC\u30D3\u30C3\u30C8\u4F4F\u5409\u5E97"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: -200,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["1992", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u30C8\u30E9\u30A4\u30A2\u30EB1\u53F7\u5E97\u958B\u5E97"
                        }), "\u798F\u5CA1\u770C\u5927\u91CE\u57CE\u5E02\u306B\u3001\u30C7\u30A3\u30B9\u30AB\u30A6\u30F3\u30C8\u30B9\u30C8\u30A2 \u30C8\u30E9\u30A4\u30A2\u30EB\u304C\u30AA\u30FC\u30D7\u30F3\u3002\uFF08\u73FE\u5728\u306F\u9589\u5E97\uFF09"]
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 141,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["1996", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC1\u53F7\u5E97\u958B\u5E97"
                        }), "\u5F53\u6642\u30A2\u30E1\u30EA\u30AB\u3067\u76DB\u6CC1\u3067\u3042\u3063\u305F\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC\u696D\u614B\u306B\u7740\u60F3\u3092\u5F97\u3066\u3001\u798F\u5CA1\u770C\u5317\u4E5D\u5DDE\u5E02\u306B\u30AA\u30FC\u30D7\u30F3\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/kitakyusyukuukou.webp",
                        alt: "\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC\u30C8\u30E9\u30A4\u30A2\u30EB\u5317\u4E5D\u5DDE\u7A7A\u6E2F\u30D0\u30A4\u30D1\u30B9\u5E97\u30AA\u30FC\u30D7\u30F3"
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  pc: 30,
                  sp: 0
                }
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitleBackground/* SectionTitleBackground */.T, {
              bgColor: "white",
              outerBgColor: "thin-blue",
              padding: {
                pc: "max(175px, ".concat((0,convertPx/* PxToVw */.g)(210, 1440), ") 0 max(120px, ").concat((0,convertPx/* PxToVw */.g)(100, 1440), ")"),
                sp: '80px 0 40px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodTitle, {
                id: "2001",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "GMS\u5C45\u629C\u306B\u3088\u308B\u5927\u91CF\u51FA\u5E97\u3068\u305F\u3086\u307E\u306CIT\u958B\u767A"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                  children: ["2001-2010", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "\u5E74"
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  pc: 0,
                  sp: 40
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodListWrapper, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodList, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2001", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "GMS\u64A4\u9000\u5F8C\u306E\u7269\u4EF6\u306B\u5C45\u629C\u51FA\u5E97\u3092\u958B\u59CB"
                        }), "\u9AD8\u5EA6\u7D4C\u6E08\u6210\u9577\u671F\u306B\u6804\u3048\u305F\u7DCF\u5408\u30B9\u30FC\u30D1\u30FC\uFF08GMS\uFF09\u696D\u614B\u3002\u6D88\u8CBB\u8005\u306E\u30CB\u30FC\u30BA\u3084\u6642\u4EE3\u306E\u5909\u5316\u3068\u5171\u306B\u3001\u53B3\u3057\u3044\u7D4C\u55B6\u72B6\u6CC1\u3092\u7406\u7531\u306B\u3001\u9589\u5E97\u3057\u3066\u3044\u304F\u5E97\u8217\u304C\u591A\u304F\u306A\u308A\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "GMS\u4ED6\u5E97\u64A4\u9000\u5F8C\u306B\u7A7A\u3044\u305F\u7269\u4EF6\u306B\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u304C\u5165\u5C45\u3059\u308B\u5F62\u3067\u51FA\u5E97\u3002\u5546\u58F2\u3092\u719F\u77E5\u3057\u305F\u5C02\u9580\u793E\u54E1\u3068\u4E00\u7DD2\u306B\u696D\u614B\u3092\u78BA\u7ACB\u3057\u306A\u304C\u3089\u3001\u65E5\u672C\u5168\u56FD\u306B\u51FA\u5E97\u3092\u52A0\u901F\u3057\u3066\u3044\u304D\u307E\u3057\u305F\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/utsunomiya.webp",
                        alt: "\u5B87\u90FD\u5BAE\u5E97"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: -200,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2003", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u4E2D\u56FD\u306B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A\u62E0\u70B9\u3092\u8A2D\u7ACB"
                        }), "\u4E2D\u56FD\u7159\u53F0\u5E02\u306B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A\u62E0\u70B9\u3092\u8A2D\u3051\u3066\u3001\u73FE\u5730\u30A8\u30F3\u30B8\u30CB\u30A2\u306E\u63A1\u7528\u306A\u3069\u3001IT\u30B7\u30B9\u30C6\u30E0\u3084\u30C7\u30D0\u30A4\u30B9\u306E\u958B\u767A\u5F37\u5316\u3092\u884C\u3044\u307E\u3057\u305F\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/vantaiTRE.webp",
                        alt: "\u4E2D\u56FD\u7159\u53F0\u5E02TRE"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: -100,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2009", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u3231\u30AB\u30A6\u30DC\u30FC\u30A4\u3092\u5B8C\u5168\u5B50\u4F1A\u793E\u5316"
                        }), "\u5317\u6D77\u9053\u306B8\u5E97\u8217\u3092\u5C55\u958B\u3057\u3066\u3044\u305F\u3001\u7CBE\u8089\u3092\u5F37\u307F\u3068\u3059\u308B\u30C7\u30A3\u30B9\u30AB\u30A6\u30F3\u30C8\u98DF\u54C1\u30B9\u30FC\u30D1\u30FC\u300C\u30AB\u30A6\u30DC\u30FC\u30A4\u300D\u3092\u5B8C\u5168\u5B50\u4F1A\u793E\u5316\u3057\u3066\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u306B\u696D\u614B\u8EE2\u63DB\u3002"]
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  pc: 30,
                  sp: 0
                }
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowWrapper, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitleBackground/* SectionTitleBackground */.T, {
              bgColor: "white",
              outerBgColor: "thin-blue",
              padding: {
                pc: "max(175px, ".concat((0,convertPx/* PxToVw */.g)(210, 1440), ") 0 max(120px, ").concat((0,convertPx/* PxToVw */.g)(100, 1440), ")"),
                sp: '80px 0 40px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodTitle, {
                id: "2010",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "\u5916\u90E8\u4F01\u696D\u3068\u4E00\u7DD2\u306B\u4FA1\u5024\u5171\u5275\u3001Smart Store Technology\u958B\u767A\u3092\u52A0\u901F"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                  children: ["2010", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "\u5E74"
                  }), "-"]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(HistoryFlowInner, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                h: {
                  pc: 0,
                  sp: 40
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodListWrapper, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodList, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2013", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u30C7\u30FC\u30BF\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u300CMD-Link\u300D\u7A3C\u50CD\u958B\u59CB"
                        }), "\u5546\u54C1\u306E\u88FD\u9020\u30E1\u30FC\u30AB\u30FC\u3068\u3001\u5E97\u8217\u306B\u4FC2\u308B\u3042\u3089\u3086\u308B\u30C7\u30FC\u30BF\u3092\u5171\u6709\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u308BMD-Link\u3092\u958B\u767A\u904B\u7528\u958B\u59CB\u3002\u30C7\u30FC\u30BF\u3092\u5171\u6709\u3057\u306A\u304C\u3089\u5168\u4F53\u6700\u9069\u3092\u56F3\u308B\u305F\u3081\u306E\u3001\u30AA\u30FC\u30D7\u30F3\u30A4\u30CE\u30D9\u30FC\u30B7\u30E7\u30F3\u3092\u5B9F\u65BD\u3002"]
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2015", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u3231\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u8A95\u751F"
                        }), "\u6301\u682A\u4F1A\u793E\u4F53\u5236\u3078\u79FB\u884C"]
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2016", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "Joint Business Plan\uFF08JBP\uFF09\u306E\u53D6\u308A\u7D44\u307F\u958B\u59CB"
                        }), "\u30E1\u30FC\u30AB\u30FC\u3084\u5378\u58F2\u4F01\u696D\u306A\u3069\u3001\u30B5\u30D7\u30E9\u30A4\u30C1\u30A7\u30FC\u30F3\u306B\u304A\u3051\u308B\u95A2\u4FC2\u5404\u793E\u3068\u4E00\u7DD2\u306B\u306A\u3063\u3066\u3001\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306B\u5B58\u5728\u3059\u308B\u30E0\u30C0\u30FB\u30E0\u30E9\u30FB\u30E0\u30EA\u3092\u89E3\u6D88\u3059\u308B\u305F\u3081\u53D6\u308A\u7D44\u307F\u3092\u958B\u59CB\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6BCE\u5E74JBP\u30B5\u30DF\u30C3\u30C8\u3092\u958B\u50AC\u3057\u3066\u3001\u696D\u754C\u306E\u8AB2\u984C\u89E3\u6C7A\u306B\u5411\u3051\u3066\u7D4C\u55B6\u30C8\u30C3\u30D7\u304C\u5354\u8B70\u3002"]
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2018", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u3231Retail AI\u8A2D\u7ACB"
                        }), "\u6C7A\u6E08\u30BF\u30D6\u30EC\u30C3\u30C8\u7AEF\u672B\u4ED8\u304D\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\uFF08Skip Cart\uFF09\u3084\u5728\u5EAB\u72B6\u6CC1\u306A\u3069\u3092\u628A\u63E1\u3059\u308BAI\u30AB\u30E1\u30E9\u306E\u958B\u767A\u306A\u3069\u3001\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306B\u5909\u9769\u3092\u3082\u305F\u3089\u3059\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3\u3092\u63D0\u4F9B\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/retailai-entrance.webp",
                        alt: "Retail\u30A8\u30F3\u30C8\u30E9\u30F3\u30B9"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
                          children: ["\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC\u30C8\u30E9\u30A4\u30A2\u30EB \u30A2\u30A4\u30E9\u30F3\u30C9\u30B7\u30C6\u30A3\u5E97", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30AA\u30FC\u30D7\u30F3"]
                        }), "Skip Cart\u3084AI\u30AB\u30E1\u30E9\u7B49\u306EIoT\u30C7\u30D0\u30A4\u30B9\u3092\u5C0E\u5165\u3057\u3001\u65B0\u3057\u3044\u8CB7\u3044\u7269\u4F53\u9A13\u304C\u3067\u304D\u308B\u65E5\u672C\u521D\u306E\u30B9\u30DE\u30FC\u30C8\u30B9\u30C8\u30A2\u3067\u3042\u308B\u300C\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC\u30C8\u30E9\u30A4\u30A2\u30EB \u30A2\u30A4\u30E9\u30F3\u30C9\u30B7\u30C6\u30A3\u5E97\u300D\uFF08\u798F\u5CA1\u5E02\u6771\u533A\uFF09\u3092\u958B\u5E97"]
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2021", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: "\u65E5\u672C\u6700\u5927\u306E\u30EA\u30C6\u30FC\u30EBDX\uFF08\u5C0F\u58F2\u306EIT/AI\u5316\uFF09\u306E\u6700\u5148\u7AEF\u57FA\u5730\u3092\u76EE\u6307\u3057\u3001\u7523\u5B98\u5B66\u306E\u307E\u3061\u3065\u304F\u308A\u3068\u3057\u3066\u30EA\u30E2\u30FC\u30C8\u30EF\u30FC\u30AF\u30BF\u30A6\u30F3 \u30E0\u30B9\u30D6\u5BAE\u82E5\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u672C\u683C\u59CB\u52D5"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2022", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: "\u6700\u5148\u7AEF\u306EIT\u6280\u8853\u3092\u5C0E\u5165\u3057\u305F\u6B21\u4E16\u4EE3\u578B\u30B9\u30DE\u30FC\u30C8\u30B9\u30C8\u30A2\u3068\u3057\u3066TRIAL GO\u8107\u7530\u5E97\uFF08\u798F\u5CA1\u770C\u5BAE\u82E5\u5E02\uFF09\u3092\u958B\u5E97"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/TRIALGO_Wakita.jpeg",
                        alt: "TRIALGO\u8107\u7530\u5E97"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2023", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: "\u3231\u9752\u68EE\u30C8\u30E9\u30A4\u30A2\u30EB\u53CA\u3073\u3231\u30C8\u30E9\u30A4\u30A2\u30EB\u30AB\u30F3\u30D1\u30CB\u30FC\u304C\u3231\u4F50\u85E4\u9577\u53CA\u3073\u3231\u9752\u68EE\u98DF\u7814\u304B\u3089\u4E00\u90E8\u4E8B\u696D\u3092\u627F\u7D99"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2024", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: "\u6771\u4EAC\u8A3C\u5238\u53D6\u5F15\u6240\u30B0\u30ED\u30FC\u30B9\u5E02\u5834\u4E0A\u5834"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "right",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2025", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                          children: "\u95A2\u6771\u3092\u4E2D\u5FC3\u306B\u5E97\u8217\u3092\u5C55\u958B\u3059\u308B\u3231\u897F\u53CB\u3092\u5B8C\u5168\u5B50\u4F1A\u793E\u5316"
                        }), "\u98DF\u6599\u54C1\uFF64\u8863\u6599\u54C1\uFF64\u4F4F\u5C45\u7528\u54C1\u306A\u3069\u3092\u8CA9\u58F2\u3059\u308B\u5C0F\u58F2\u30C1\u30A7\u30FC\u30F3\u300C\u897F\u53CB\u300D\u3092\u5B8C\u5168\u5B50\u4F1A\u793E\u5316\u3002245\u5E97\u8217\u304C\u30B0\u30EB\u30FC\u30D7\u5165\u308A\u3002"]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
                      h: {
                        pc: 20,
                        sp: 22
                      }
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PeriodImageWrapper, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                        src: "/images/Store_SEIYU.png",
                        alt: "\u897F\u53CB\u5E97"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PeriodItem, {
                    circlePosition: "left",
                    top: 0,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
                      children: ["2026", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "\u5E74"
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                        children: "TOPIX\uFF08\u6771\u8A3C\u682A\u4FA1\u6307\u6570\uFF09\u69CB\u6210\u9298\u67C4\u3078\u306E\u65B0\u898F\u63A1\u7528"
                      })
                    })]
                  })]
                })
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CardLinksDiv, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            pc: 130,
            sp: 0
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLinks/* CompanyLinks */.b, {
          padding: {
            pc: '0px auto 0'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            pc: 130,
            sp: 0
          }
        })]
      })]
    })]
  });
};

HistoryPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Corporate Information',
    subTitle: '企業情報'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '企業情報',
    path: '/company/'
  }, {
    name: '会社沿革',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    children: page
  }));
};

var HistoryMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__HistoryMainWrapper",
  componentId: "sc-1s7qbrl-0"
})(["overflow:hidden;"]);
var HistoryMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__HistoryMain",
  componentId: "sc-1s7qbrl-1"
})([""]);
var HistoryFlow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__HistoryFlow",
  componentId: "sc-1s7qbrl-2"
})([""]);
var HistoryFlowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__HistoryFlowWrapper",
  componentId: "sc-1s7qbrl-3"
})(["margin:0 calc(50% - 50vw);width:100vw;background-color:", ";position:relative;&::after{content:'';width:2px;height:100%;background-color:#fff;position:absolute;left:50%;top:0;}@media screen and (max-width:1047px){padding-bottom:50px;&::after{display:none;}&:last-child{padding-bottom:80px;}}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
var HistoryFlowInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__HistoryFlowInner",
  componentId: "sc-1s7qbrl-4"
})(["width:1040px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:0 20px;}"]);
var PeriodTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__PeriodTitle",
  componentId: "sc-1s7qbrl-5"
})(["position:relative;text-align:center;font-family:", ";font-weight:bold;color:", ";z-index:9;h3{font-size:38px;}p{font-size:18px;line-height:34px;letter-spacing:0.36px;color:", ";}span{font-size:22px;}@media screen and (max-width:1047px){h3{font-size:32px;}span{font-size:20px;}}"], theme/* theme.fontEn */.r.fontEn, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.textTitle */.r.colors.textTitle);
var PeriodListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__PeriodListWrapper",
  componentId: "sc-1s7qbrl-6"
})([""]);
var PeriodList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__PeriodList",
  componentId: "sc-1s7qbrl-7"
})(["width:50%;@media screen and (max-width:1047px){width:100%;}"]);
var PeriodItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__PeriodItem",
  componentId: "sc-1s7qbrl-8"
})(["margin-top:", ";position:relative;left:", ";h4{font-family:", ";font-size:30px;color:", ";border-bottom:1px solid ", ";position:relative;padding-bottom:16px;padding-left:", ";&::after{content:'';width:10px;height:10px;border-radius:50%;background-color:", ";display:inline-block;position:absolute;bottom:0;transform:translate(50%,50%);z-index:9;", ";transform:", ";}}span{font-size:20px;font-weight:bold;}ul{margin-top:30px;list-style-type:none;width:464px;box-sizing:content-box;padding-left:", ";}li{line-height:16px;letter-spacing:0.32px;line-height:26px;margin-top:40px;}h5{font-size:18px;font-weight:bold;letter-spacing:0.36px;line-height:26px;color:", ";margin-bottom:14px;}div{padding-left:", ";}@media screen and (max-width:1047px){left:0;margin-top:50px;text-align:left;&:first-child{margin-top:0;}h4{display:inline-block;font-size:30px;padding-bottom:11px;padding-left:0;&:after{display:none;}}ul{padding-left:0;width:100%;box-sizing:border-box;text-align:left;margin-top:32px;}li{font-size:15px;line-height:25px;margin-top:32px;br{display:none;}}h5{margin-bottom:12px;}div{padding-left:0;}}"], function (_ref) {
  var top = _ref.top;
  return "".concat(top, "px");
}, function (_ref2) {
  var circlePosition = _ref2.circlePosition;
  return circlePosition === 'left' ? '100%' : '';
}, theme/* theme.fontEn */.r.fontEn, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref3) {
  var circlePosition = _ref3.circlePosition;
  return circlePosition === 'left' ? '30px' : '';
}, theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref4) {
  var circlePosition = _ref4.circlePosition;
  return "".concat(circlePosition, ": 0");
}, function (_ref5) {
  var circlePosition = _ref5.circlePosition;
  return circlePosition === 'right' ? 'translate(50%, 50%)' : 'translate(-50%, 50%)';
}, function (_ref6) {
  var circlePosition = _ref6.circlePosition;
  return circlePosition === 'right' ? '0px' : '30px';
}, theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref7) {
  var circlePosition = _ref7.circlePosition;
  return circlePosition === 'left' ? '30px' : '0';
});
var PeriodImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__PeriodImageWrapper",
  componentId: "sc-1s7qbrl-9"
})(["display:flex;align-items:flex-start;justify-content:", ";gap:30px;margin-right:40px;& + ul{margin-top:33px;}img{max-width:450px;border-radius:10px;}@media screen and (max-width:1047px){flex-direction:column;align-items:center;margin-right:0;img{max-width:100%;height:auto;}}"], function (_ref8) {
  var justifyContent = _ref8.justifyContent;
  return justifyContent;
});
var NoteDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__NoteDiv",
  componentId: "sc-1s7qbrl-10"
})(["width:1040px;margin:64px auto 0;@media screen and (max-width:1047px){width:100%;margin:50px 0 0;}"]);
var Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "History__Note",
  componentId: "sc-1s7qbrl-11"
})(["line-height:30px;letter-spacing:0.32px;font-weight:400;@media screen and (max-width:1047px){padding:0 20px;font-size:15px;line-height:25px;letter-spacing:0.3px;}"]);
var CardLinksDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "History__CardLinksDiv",
  componentId: "sc-1s7qbrl-12"
})(["width:100%;background-color:", ";@media screen and (max-width:1047px){display:none;}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
;// CONCATENATED MODULE: ./src/pages/company/history.tsx


/***/ }),

/***/ 49169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/history",
      function () {
        return __webpack_require__(83193);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(49169); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);